import { atom, useAtom } from 'jotai'

const fetchInsurancePromptAtom = atom<'INITIAL' | 'OPEN' | 'CONFIRM' | 'SKIP'>('INITIAL')
let resolver: (value: 'CONFIRM' | 'SKIP') => void = () => {}

export function useFetchInsurancePrompt() {
  const [state, setState] = useAtom(fetchInsurancePromptAtom)

  return {
    state,
    async prompt() {
      setState('OPEN')
      return new Promise<'CONFIRM' | 'SKIP'>((resolve) => {
        resolver = resolve
      })
    },
    confirm() {
      setState('CONFIRM')
      resolver('CONFIRM')
    },
    skip() {
      setState('SKIP')
      resolver('SKIP')
    },
  }
}
